import { render, staticRenderFns } from "./MaterialPagination.vue?vue&type=template&id=96712620&"
import script from "./MaterialPagination.vue?vue&type=script&lang=js&"
export * from "./MaterialPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96712620')) {
      api.createRecord('96712620', component.options)
    } else {
      api.reload('96712620', component.options)
    }
    module.hot.accept("./MaterialPagination.vue?vue&type=template&id=96712620&", function () {
      api.rerender('96712620', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/materialsRequests/components/MaterialPagination.vue"
export default component.exports